import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full bg-brand-black my-auto px-4 pt-14 z-50" }
const _hoisted_2 = { class: "flex flex-col space-y-6" }
const _hoisted_3 = { class: "flex flex-col w-full space-y-2" }
const _hoisted_4 = {
  key: 0,
  class: "flex text-white text-2xl font-medium"
}
const _hoisted_5 = {
  key: 1,
  class: "text-brand-light-gray text-lg"
}
const _hoisted_6 = {
  key: 2,
  class: "flex text-white text-2xl font-medium"
}
const _hoisted_7 = {
  key: 3,
  class: "text-brand-light-gray text-lg"
}
const _hoisted_8 = { class: "flex m-auto space-x-2.5" }
const _hoisted_9 = { class: "my-auto pt-0.5" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }

import {
  IonContent,
  IonPage, onIonViewWillEnter, useIonRouter,
} from '@ionic/vue';
import {defineComponent, ref} from 'vue';
import InputField from "@/components/InputField.vue";
import ApiService from "@/services/api/apiService";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {Preferences} from "@capacitor/preferences";
import {PreferenceKey} from "@/definitions/PreferenceKey";
import {AccountType} from "@/definitions/AccountType";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountOnboardingNamePage',
  setup(__props) {

const busy = ref(false)
const name = ref('')
const errors = ref({})
const ionRouter = useIonRouter()
const accountType = ref()

onIonViewWillEnter(async () => {
  Observable.emit(ObservableEvent.IonRouterOutletChanged, ionRouter.canGoBack())
  accountType.value = (await Preferences.get({key: PreferenceKey.OnboardingAccountType})).value
})

const forward = async () => {
  if (!name.value || busy.value) return
  errors.value = {}
  busy.value = true
  try {
    await ApiService.User().setName(name.value)
    await ionRouter.navigate('/account/onboarding/bio', 'forward', 'push')
  } catch (e: any) {
    if (!e.data) return
    if (e.data.errors) errors.value = e.data.errors
  } finally {
    busy.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (accountType.value !== _unref(AccountType).Club)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Username"))
                  : _createCommentVNode("", true),
                (accountType.value !== _unref(AccountType).Club)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Pineapple encourages the use of imaginary names. Be open, never exposed. "))
                  : _createCommentVNode("", true),
                (accountType.value === _unref(AccountType).Club)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Club name"))
                  : _createCommentVNode("", true),
                (accountType.value === _unref(AccountType).Club)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Enter your club or business name."))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(InputField, {
                error: errors.value && errors.value['name'] ? errors.value['name'][0] : undefined,
                modelValue: name.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                type: "text",
                counter: true,
                "max-length": 20,
                enterkeyhint: "next",
                onOnKeyEnter: forward,
                placeholder: "Start typing..."
              }, null, 8, ["error", "modelValue"])
            ]),
            _createElementVNode("button", {
              onClick: forward,
              class: _normalizeClass([{
              'bg-opacity-40' : !name.value.length
            }, "mt-10 flex w-full bg-brand-lime rounded-full px-8 h-14 font-medium text-xl text-brand-black transition-all"])
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (!busy.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Continue"))
                    : _createCommentVNode("", true),
                  (busy.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[1] || (_cache[1] = [
                        _createElementVNode("svg", {
                          class: "animate-spin h-5 w-5 text-brand-black",
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          })
                        ], -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 2)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})